/**
 * Atlassian OAuth callback URL, resolved per environment.
 *
 * The redirect_uri sent to auth.atlassian.com must match — exactly — one of the
 * callback URLs registered in the Atlassian OAuth app, and must be identical at
 * authorize time and at code-exchange time.
 *
 * - Local dev server (`vite dev`, import.meta.env.DEV): the current origin
 *   (http://localhost:<port>), so the running port is always correct.
 * - Hosted builds (dev / staging / prod): the fixed `VITE_ATLASSIAN_REDIRECT_URI`
 *   for that environment; falls back to the current origin when it is unset.
 */
export function atlassianRedirectUri(): string {
  const path = '/callbacks/atlassian_oauth'
  const fixed = import.meta.env.VITE_ATLASSIAN_REDIRECT_URI as string | undefined
  if (import.meta.env.DEV || !fixed) return `${window.location.origin}${path}`
  return fixed
}
